import { StyleSheet } from 'aphrodite';
import { addAlphaToHex } from '../../../../../../models/UiUtils';
import { THEME } from '../../../../../components-v2/Theme/theme';
// brandPrimary is kept as a hex literal because addAlphaToHex requires a raw hex string — it cannot accept a CSS variable.
import { brandPrimary } from '../../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	bar: {
		display: 'flex',
		gap: THEME.spacing.md,
		width: '100%',
	},
	/**
	 * Applied to each Button so they expand equally to fill the bar.
	 * Styling matches V1's `addQuestionButton` (`AdditionalQuestions/styles.ts`):
	 * 2px dashed brandPrimary border, 10% blue-tint background, brandPrimary text.
	 */
	button: {
		flexGrow: 1,
		flexBasis: 0,
		color: THEME.colors.primary.main,
		background: addAlphaToHex(brandPrimary, 0.1, '#FFFFFF'),
		border: `2px dashed ${THEME.colors.primary.main}`,
	},
	/** Spacing between the leading AddSectionIcon and the "Add Section" label. */
	addSectionIcon: {
		marginRight: THEME.spacing.xs,
		verticalAlign: 'middle' as const,
	},
});
